module.exports = __webpack_public_path__ + "img/news-10.b0ebf770.jpeg";